<template>
  <div>
    <div id="producePrint" style="padding:10px">
    <el-button class="printButton" style="float:right" type="primary" size="small" @click="chengeFont">切换字体打印</el-button>
      <el-row type="flex" justify="center" style="position:relative">
        <img
          src="../assets/lyLogo.jpg"
          style="position:absolute;left:20px;width:100px;height:100px;top:-20px"
        />
        <h1 style="font-family:SimSun;margin:30px;margin-top:10px">生产派工单</h1>
      </el-row>
      <div id="fontContainer">
      <el-row style="margin-bottom:5px" type="flex" justify="space-around">
        <span>客户名称：{{info.customer_name}}</span>
        <span></span>
        <span>总工时：{{Number(info.need_hour).toFixed(2)}}</span>
      </el-row>
      <table class="topTable">
        <tr class="labelWidth">
          <td>来料品名</td>
          <td>{{info.product_name}}</td>
          <td>供料厂商</td>
          <td>{{info.supplier}}</td>
        </tr>
        <tr class="labelWidth">
          <td>来料日期</td>
          <td>{{info.come_date}}</td>
          <td>加工规格</td>
          <td>{{info.product_size}}</td>
        </tr>
        <tr class="labelWidth">
          <td>来料数量</td>
          <td>{{info.come_count}}</td>
          <td>表面处理</td>
          <td>{{info.face}}</td>
        </tr>
      </table>
      <table class="underTable">
          <tr>
            <td>序号</td>
            <td>加工步骤</td>
            <td>工艺要求</td>
          </tr>
          <tr v-for="(item,index) in info.process" :key="index" class="contentItem">
            <td>{{index+1}}</td>
            <td>{{info.process[index] ? info.process[index].description : ''}}</td>
            <td v-if="info.process[index]">
              <span v-for="(req,idx) in info.process[index].require.split(/;|；/)" :key="idx">
              <span v-if="req!==''">
                <span v-if="req.indexOf('/')===-1" style="display:inline-block">
                  {{['①','②','③','④','⑤','⑥','⑦','⑧','⑨','⑩','⑪','⑫'][idx]+req.replace('@','↧').replace('^','φ')}}
                </span>
                <span style="display:inline-block" v-else>
                  <span style="display:inline-block;text-align:right">
                    {{['①','②','③','④','⑤','⑥','⑦','⑧','⑨','⑩','⑪','⑫'][idx]+req.split(/[+|-]/)[0]}}
                    </span>
                    <span style="position:relative;width:50px;display:inline-block">
                      <sup
                      style="position:absolute;left:-2px;bottom:5px;width:40px;display:inline-block;line-height:10px;text-align:left;font-size:10px;transform:scale(.8)"
                    >{{req.match(/[+|-]/)[0]+req.split(/[+|-]/)[1].split('/')[0]}}</sup>
                    <sub
                      style="position:absolute;left:0px;top:-5px;width:40px;display:inline-block;line-height:10px;text-align:left;font-size:10px;transform:scale(.8)"
                    >{{req.match(/\/(.)/)[1]+req.split(/[+|-]/)[2]}}</sub>
                    </span>
                </span>
              </span>
              </span>
            </td>
            <td v-else></td>
          </tr>
        <!-- <tr id="paddingCol">
          <td colspan="3"></td>
        </tr> -->
      </table>
      <span>※请保持派工单表面整洁及完整！加工完毕交于品管保存。</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      info: JSON.parse(this.$route.query.info),
      smallFont: false
    }
  },
  mounted () {
    setTimeout(() => {
      window.print()
    }, 500)
  },
  methods: {
    chengeFont () {
      if (this.smallFont) {
        document.getElementById('fontContainer').classList.remove('smallFont')
        this.smallFont = false
        window.print()
      } else {
        document.getElementById('fontContainer').classList.add('smallFont')
        this.smallFont = true
        window.print()
      }
    }
  }
}
</script>

<style>
.smallFont{
  font-size: 12px;
}
.underTable {
  margin-top: -1px;
}
#producePrint table,
#producePrint table tr th,
#producePrint table tr td {
  border: 1px solid #000000;
}
#producePrint table {
  text-align: center;
  border-collapse: collapse;
  width: 100%;
}
@media print {
  /* .underTable td{
    height: 2cm;
  } */
  /* .underTable tr:last-child{
    height: attr(ident);
  } */
  .underTable tr:nth-child(1) td:nth-child(1){
    width: 1cm;
  }
  .underTable tr:nth-child(1) td:nth-child(2){
    width: 2.8cm;
  }
  /* .underTable tr:nth-child(1) td:nth-child(3){
    width: 1cm;
  } */
  /* #producePrint{
    display: block;
  } */
  #producePrint table {
    line-height: 0.8cm;
  }
  #producePrint .labelWidth td:nth-child(1) {
    width: 2cm;
  }
  #producePrint .labelWidth td:nth-child(3) {
    width: 2cm;
  }
  #producePrint img {
    width: 1.5cm;
    height: 1.5cm;
  }
}
@page :pseudo-class {
  size: A5;
}
@media print{
  #producePrint .printButton{
    display: none;
  }
}
</style>
